/**
 * Converts a backend score (0-10 scale, decimal) to the Ultimate Team display scale (0-99).
 * Used in ALL frontend renders that show a session score, KPI score, or category score.
 * The backend always persists in 0-10 — never expose that scale to the user.
 */
export function toScore99(score10: number): number {
  if (!Number.isFinite(score10)) return 0;
  return Math.round(Math.min(99, Math.max(0, score10 * 9.9)));
}

/**
 * Formats a backend score (0-10) as the displayable string "XX/99".
 * Use it whenever the slash-99 suffix is rendered together with the number.
 */
export function formatScore99(score10: number): string {
  return `${toScore99(score10)}/99`;
}
